var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"ptop-lg padded"},[_c('h1',{staticClass:"mtop-xl mbottom-xl"},[_vm._v("Page Unavailable")]),_c('div',{staticClass:"mbottom-xl mtop-xl ptop-xl pbottom-xl"})])])
}]

export { render, staticRenderFns }